Drupal.behaviors.mainMenu = {
  attach(context) {
    const toggleExpand = context.querySelector("#toggle-expand");
    const menu = context.querySelector("#main-nav");
    const toggleClose = context.querySelector("#toggle-close");

    if (menu && toggleExpand && toggleClose) {
      const expandMenu = menu.querySelectorAll(".expand-sub");

      // Mobile Menu Show/Hide.
      if (!toggleExpand.classList.contains("processed")) {
        toggleExpand.addEventListener("click", (e) => {
          menu.classList.toggle("main-nav--open");
          e.preventDefault();
        });
        toggleExpand.classList.add("processed");
      }

      if (!toggleClose.classList.contains("processed")) {
        toggleClose.addEventListener("click", (e) => {
          menu.classList.toggle("main-nav--open");
          e.preventDefault();
        });
        toggleClose.classList.add("processed");
      }

      // Expose mobile sub menu on click.
      expandMenu.forEach((item) => {
        if (!item.classList.contains("processed")) {
          item.addEventListener("click", (e) => {
            const menuItem = e.currentTarget;
            const subMenu = menuItem.nextElementSibling;

            menuItem.classList.toggle("expand-sub--open");
            subMenu.classList.toggle("main-menu--sub-open");
          });
          item.classList.add("processed");
        }
      });
    }
  },
};
